import { useCallback, useContext, useState } from 'react';
import { RuntimeContext } from 'src/runtimeContext.ts';

export function useListDisplayMode(): [boolean, () => void] {
    const { userOptionsClient } = useContext(RuntimeContext);
    const [isListDisplayModeEnabled, setIsListDisplayModeEnabled] = useState(
        userOptionsClient.isListDisplayModeEnabled(),
    );

    const toggleListDisplayMode = useCallback(() => {
        userOptionsClient.toggleDisplayMode().then((result: boolean) => setIsListDisplayModeEnabled(result));
    }, [userOptionsClient]);

    return [isListDisplayModeEnabled, toggleListDisplayMode];
}
